import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldCheck, FileText, Check } from "lucide-react";

const DOCS = [
  ["Welcome Letter", "Your official welcome and next steps."],
  ["Church School Enrollment Form", "Signed 3-part form for your local B.O.E. superintendent."],
  ["BOE Instructions", "A step-by-step guide for notifying your school district."],
  ["Records Request", "A ready-to-send letter to request records from a previous school."],
];

export default function CoverSchool() {
  return (
    <div>
      <div className="border-b border-border bg-card/40">
        <div className="mx-auto max-w-5xl px-5 py-16 lg:px-8">
          <span className="label-caps text-primary">Alabama Church School Cover</span>
          <h1 className="mt-2 font-head text-4xl font-black leading-tight sm:text-5xl">Homeschool Legally in Alabama</h1>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground">Hornsby Church School provides the legal umbrella your homeschool needs under Alabama law (Code of Alabama §16-28-1) — with instant enrollment documents in your portal. You choose your own curriculum and how you teach.</p>
          <div className="mt-6 flex flex-wrap items-center gap-4">
            <Link to="/cover-school/enroll" data-testid="cover-enroll-cta">
              <Button className="rounded-none label-caps bg-primary px-8 py-6 text-base hover:bg-primary/80">Start Enrollment · $113/yr</Button>
            </Link>
            <span className="label-caps text-muted-foreground">Alabama only · Per family, per year</span>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-5xl px-5 py-14 lg:px-8">
        <div className="grid gap-8 md:grid-cols-2">
          <div>
            <div className="flex items-center gap-2 text-primary"><ShieldCheck className="h-5 w-5" /><span className="label-caps">What It Is</span></div>
            <h2 className="mt-2 font-head text-2xl font-bold">Legal cover — not curriculum</h2>
            <p className="mt-3 text-muted-foreground">Enrollment in the cover school is a <strong>separate service</strong> from our K–12 curriculum. Buying curriculum does not enroll your child, and cover-school enrollment does not include lessons. Use one, the other, or both.</p>
            <ul className="mt-5 space-y-3">
              {["Operate under Alabama's church-school statute", "No curriculum requirements, no state testing", "Enroll your whole family for one flat price", "All documents delivered instantly to your portal"].map((f) => (
                <li key={f} className="flex items-start gap-3"><Check className="mt-0.5 h-5 w-5 shrink-0 text-primary" /><span>{f}</span></li>
              ))}
            </ul>
          </div>
          <div className="border border-border bg-card p-8">
            <div className="flex items-center gap-2 text-primary"><FileText className="h-5 w-5" /><span className="label-caps">What You Receive</span></div>
            <h2 className="mt-2 font-head text-2xl font-bold">Documents in your portal</h2>
            <div className="mt-5 space-y-4">
              {DOCS.map(([t, d]) => (
                <div key={t} className="border-l-2 border-primary/50 pl-4">
                  <p className="font-bold">{t}</p>
                  <p className="text-sm text-muted-foreground">{d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 border border-border bg-card p-8 text-center">
          <p className="font-head text-3xl font-black">$113 <span className="text-lg font-normal text-muted-foreground">/ family / year</span></p>
          <p className="mt-2 text-sm text-muted-foreground">Flat rate — no per-child fees. Renews each year. Alabama families only.</p>
          <Link to="/cover-school/enroll"><Button className="mt-5 rounded-none label-caps bg-primary px-8 py-6 hover:bg-primary/80" data-testid="cover-enroll-cta-2">Enroll Your Family</Button></Link>
          <p className="mt-3 text-xs text-muted-foreground">Secure card payment powered by Stripe · A free account is required so your documents are saved to your portal.</p>
        </div>
      </div>
    </div>
  );
}
